/**
 * 사용안함. 대신 Assets.vue 사용
 */
import axios from "axios";
import CONF from "@/Config.js";

const getInitialState = () => {
  const savedSkin = localStorage.getItem('style_skin');
  const savedMedia = localStorage.getItem('style_media');
  
  return {
    skin: savedSkin || '/* 스킨 CSS를 여기에 작성하세요 */',
    media: savedMedia || '/* 미디어쿼리를 여기에 작성하세요 */'
  };
};

const state = getInitialState();

const mutations = {
  //updateSkin(state, code) {
  //  state.skin = code;
  //  localStorage.setItem('style_skin', code);
  //},
  updateMedia(state, code) {
    state.media = code;
    localStorage.setItem('style_media', code);
  },
  updateScss(state, code) {
    state.scss = code;
  }
};

const actions = {
  //async saveStyles({ commit }, { code, type, fileType }) {
  //  try {
  //    const response = await axios.post('/api/styles/save', {
  //      code,
  //      type,
  //      fileType
  //    });
  //    
  //    if (type === 'skin') {
  //      commit('updateSkin', code);
  //    } else {
  //      commit('updateMedia', code);
  //    }
  //    
  //    return response.data;
  //  } catch (error) {
  //    console.error('스타일 저장 실패:', error);
  //    throw error;
  //  }
  //},

  // eslint-disable-next-line no-empty-pattern
  async loadStyleFile({ }, { barcode }) {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(`${CONF.API_URL}/textbook/editor/textbookContents/${barcode}/style`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      //console.log(barcode);
      //console.log(response.data);
      return response.data;
    } catch (error) {
      console.error('스타일 파일 로드 실패:', error);
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async saveFile({ commit }, { code, type, barcode }) {
    try {
      const token = localStorage.getItem("access_token"); 
      const response = await axios.post(`${CONF.API_URL}/textbook/editor/textbookContents/${barcode}/style`, {
        code
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error('스타일 파일 저장 실패:', error);
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}; 